import { render, staticRenderFns } from "./Families.vue?vue&type=template&id=9d67bae0&"
import script from "./Families.vue?vue&type=script&lang=js&"
export * from "./Families.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports